import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import SemakLesen from "./pages/SemakLesen";

// Simple placeholder page for other routes
const ComingSoon = ({ title, language }) => (
  <div className="min-h-screen flex flex-col items-center justify-center" style={{ backgroundColor: '#f5f6fa' }}>
    <div className="text-center p-8 bg-white rounded-xl shadow-sm max-w-md">
      <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
        style={{ backgroundColor: '#f0f4ff' }}>
        <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="#003580" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">{title}</h2>
      <p className="text-gray-500 text-sm">
        {language === 'bm' ? 'Laman ini sedang dalam pembangunan.' : 'This page is under development.'}
      </p>
    </div>
  </div>
);

function App() {
  const [language, setLanguage] = useState('bm');

  return (
    <div className="App flex flex-col min-h-screen">
      <BrowserRouter>
        <Header language={language} setLanguage={setLanguage} />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home language={language} />} />
            <Route path="/semak-lesen" element={<SemakLesen language={language} />} />
            <Route path="/pembaharuan" element={<ComingSoon title={language === 'bm' ? 'Pembaharuan Lesen' : 'License Renewal'} language={language} />} />
            <Route path="/semak-saman" element={<ComingSoon title={language === 'bm' ? 'Semak Saman' : 'Check Summons'} language={language} />} />
            <Route path="/pertukaran" element={<ComingSoon title={language === 'bm' ? 'Pertukaran Lesen Asing' : 'Foreign License Exchange'} language={language} />} />
            <Route path="/status" element={<ComingSoon title={language === 'bm' ? 'Status Permohonan' : 'Application Status'} language={language} />} />
            <Route path="/cawangan" element={<ComingSoon title={language === 'bm' ? 'Cari Cawangan' : 'Find Branch'} language={language} />} />
            <Route path="/hubungi" element={<ComingSoon title={language === 'bm' ? 'Hubungi Kami' : 'Contact Us'} language={language} />} />
            <Route path="/faq" element={<ComingSoon title="FAQ" language={language} />} />
            <Route path="*" element={<ComingSoon title="404 - Halaman Tidak Dijumpai" language={language} />} />
          </Routes>
        </main>
        <Footer language={language} />
      </BrowserRouter>
    </div>
  );
}

export default App;
